import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useNavigate } from "react-router-dom";

const DEFAULT_QUEST_IMAGE =
  "https://yuvaquest-public-bucket-s3.s3.us-east-2.amazonaws.com/static/studentadmin/congratulations/certificate/Certificate.png";

/**
 * @typedef {Object} UnlockCertificatePopupProps
 * @property {boolean} showModal - Controls the visibility of the modal
 * @property {() => void} handleClose - Function to close the modal
 * @property {string} [questImage] - Optional quest image URL (falls back to default)
 */

const UnlockCertificatePopup = ({
  showModal,
  handleClose,
  questImage,
  modalTitle,
  modalDesc,
}) => {
  const navigate = useNavigate();

  const imageUrl = questImage || DEFAULT_QUEST_IMAGE;

  const handleAddStudent = () => {
    handleClose();
    navigate("/add-student");
  };

  return (
    <Modal
      show={showModal}
      onHide={handleClose}
      centered
      size="lg"
      className="custom-modal"
    >
      <Modal.Body
        className="px-4 py-4 px-md-5 text-center"
        style={{
          background: "linear-gradient(180deg, #ffffff, #DEDBFF)",
          borderRadius: "12px",
          position: "relative",
        }}
      >
        <div
          onClick={handleClose}
          style={{
            position: "absolute",
            top: "15px",
            right: "20px",
            cursor: "pointer",
            fontSize: "20px",
            color: "#888",
            fontWeight: "bold",
          }}
        >
          ✕
        </div>
        {/* 🎉 Title */}
        <h3 style={{ fontWeight: "800", color: "#0B20A5" }}>
          🎉 {modalTitle || "HURRAY! QUEST COMPLETED"} 🎉
        </h3>

        <p style={{ fontSize: "18px" }}>
          {modalDesc || "Your Certificate is Ready."}
        </p>

        {/* Subtitle */}

        {/* Image */}
        <div className="row align-items-center justify-content-center text-center my-4">
          <div className="col-md-5">
            <div style={{ position: "relative", display: "inline-block" }}>
              <img
                src={imageUrl}
                alt="Quest"
                style={{
                  width: "auto",
                  height: "120px",
                  objectFit: "cover",
                  borderRadius: "6px",
                  filter: "blur(1px)",
                }}
              />
              <div
                style={{
                  position: "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                  background: "#0d1b3e",
                  borderRadius: "50%",
                  width: "40px",
                  height: "40px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <i className="bi bi-lock-fill" style={{ color: "#fff" }} />
              </div>
            </div>
          </div>

          {/* ✅ Features */}
          <div className="col-md-7" style={{ textAlign: "left" }}>
            {[
              "Unlimited access to full platform on any device.",
              "Unlock all series and episodes.",
              "Separate profiles and progress trackers for each of your kids.",
              "Knowledge on temples, monuments, shlokas, freedom fighters, festivals and ancient characters.",
              "Win virtual trophies and certificates for encouragement.",
            ].map((text, i) => (
              <div key={i} style={{ display: "flex", marginBottom: "8px" }}>
                <span
                  style={{
                    color: "white",
                    marginRight: "8px",
                    backgroundColor: "#63A844",
                    padding: "2px 6px",
                    borderRadius: "50%",
                    fontSize: "12px",
                    height: "fit-content",
                  }}
                >
                  ✔
                </span>
                <span style={{ fontSize: "14px" }}>{text}</span>
              </div>
            ))}
          </div>
        </div>

        {/* Button */}
        <Button
          onClick={handleAddStudent}
          style={{
            width: "100%",
            borderRadius: "10px",
            background: "#004DF4",
            border: "none",
            fontWeight: "600",
            padding: "10px",
          }}
        >
          Continue to Unlock →
        </Button>

        {/* Secondary */}
        {/* <div
          onClick={handleClose}
          style={{
            marginTop: "10px",
            cursor: "pointer",
            color: "#666",
            fontSize: "14px",
          }}
        >
          Maybe Later
        </div> */}
      </Modal.Body>
    </Modal>
  );
};

export default UnlockCertificatePopup;
